module.exports = __webpack_public_path__ + "static/img/company-rule-mobile.0590885.png";